import { render } from "./EnglishGuideline.vue?vue&type=template&id=e8e85f1c&scoped=true"
import script from "./EnglishGuideline.vue?vue&type=script&lang=js"
export * from "./EnglishGuideline.vue?vue&type=script&lang=js"

import "./EnglishGuideline.vue?vue&type=style&index=0&id=e8e85f1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e85f1c"]])

export default __exports__